var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B3954;}\n\t.st1{fill:#16ADE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.3,108.3v43.1c51,6.8,90.4,50.6,90.4,103.5c0,52.9-39.4,96.6-90.4,103.4v43.1    c74.8-7.1,133.2-70,133.2-146.6C419.5,178.3,361,115.4,286.3,108.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "258.2,65.9 258.2,29.3 226.1,29.3 226.1,47.9 194.1,47.9 194.1,65.9 226.1,65.9   "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.3,79.9H180v126.2h92.3V79.9z M226.1,148.2c-11.2,0-20.3-9.1-20.3-20.3s9.1-20.3,20.3-20.3      s20.3,9.1,20.3,20.3S237.3,148.2,226.1,148.2z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "237.9,258.4 237.9,234.7 260.5,234.7 260.5,220.1 191.7,220.1 191.7,234.7 214.4,234.7 214.4,258.4       "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "272.3,402.1 272.3,343.3 168.2,343.3 168.2,318.7 128.7,318.7 128.7,402.1 168.2,402.1   "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.7,402.1H92.5v27.6h64.1c3.9,0,7,3.1,7,7c0,3.9-3.1,7-7,7H92.5v38.9H371v-66.5l-256.3-0.1V402.1z       M313.3,424.3c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8c-10.4,0-18.9-8.4-18.9-18.8S302.9,424.3,313.3,424.3z       M172.1,435.4c0.1-0.5,0.2-0.9,0.4-1.3c0.2-0.4,0.4-0.8,0.6-1.2c0.3-0.4,0.5-0.7,0.9-1.1c1.6-1.6,4.1-2.4,6.3-1.9      c0.4,0.1,0.9,0.2,1.3,0.4c0.4,0.2,0.8,0.4,1.2,0.6c0.4,0.3,0.7,0.6,1.1,0.9c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.4,0.5,0.8,0.6,1.2      c0.2,0.4,0.3,0.9,0.4,1.3c0.1,0.4,0.1,0.9,0.1,1.4c0,0.5,0,0.9-0.1,1.4c-0.1,0.5-0.2,0.9-0.4,1.3c-0.2,0.4-0.4,0.8-0.6,1.2      s-0.6,0.7-0.9,1.1c-0.3,0.3-0.7,0.6-1.1,0.9c-0.4,0.3-0.8,0.5-1.2,0.6c-0.4,0.2-0.9,0.3-1.3,0.4c-0.5,0.1-0.9,0.1-1.4,0.1      c-0.4,0-0.9,0-1.4-0.1c-0.4-0.1-0.9-0.2-1.3-0.4c-0.4-0.2-0.8-0.4-1.2-0.6c-0.4-0.3-0.7-0.5-1.1-0.9c-0.3-0.3-0.6-0.7-0.9-1.1      c-0.3-0.4-0.5-0.8-0.6-1.2c-0.2-0.4-0.3-0.9-0.4-1.3s-0.1-0.9-0.1-1.4C172,436.3,172,435.8,172.1,435.4z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 93.7,
    width: 21.3,
    x: 144.7,
    y: 96.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.0ce469d776dd5a67e4c753d9579ad3d2.svg";
export { ForwardRef as ReactComponent };